import { c as _c } from "react/compiler-runtime";
import { IcoGoogle24 } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
import type { ButtonAsButtonProps } from '../button';
import Button from '../button';
type OverrideButtonProps = {
  children?: string;
};
export type GoogleButtonProps = Omit<ButtonAsButtonProps, 'variant'> & OverrideButtonProps;
const GoogleButton = t0 => {
  const $ = _c(13);
  const {
    children,
    disabled,
    fullWidth,
    loading,
    loadingAriaLabel,
    onClick,
    size,
    testID,
    type
  } = t0;
  const {
    t
  } = useTranslation("ui");
  let t1;
  if ($[0] !== children || $[1] !== t) {
    t1 = children ?? t("components.google-button.children-default");
    $[0] = children;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== disabled || $[4] !== fullWidth || $[5] !== loading || $[6] !== loadingAriaLabel || $[7] !== onClick || $[8] !== size || $[9] !== t1 || $[10] !== testID || $[11] !== type) {
    t2 = <Button disabled={disabled} fullWidth={fullWidth} loading={loading} loadingAriaLabel={loadingAriaLabel} onClick={onClick} size={size} testID={testID} type={type} variant="secondary" prefixIcon={IcoGoogle24}>{t1}</Button>;
    $[3] = disabled;
    $[4] = fullWidth;
    $[5] = loading;
    $[6] = loadingAriaLabel;
    $[7] = onClick;
    $[8] = size;
    $[9] = t1;
    $[10] = testID;
    $[11] = type;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};
export default GoogleButton;